<template>
  <div class="side-menu pt-5">
    <ToCategoryBtn class="ma-3" />
    <ul class="links">
      <NavLink
        v-for="link in $store.getters['Category/getRootCategories']"
        :isSubCategory="true"
        :title="link.title"
        :key="link.id"
        :navigationName="link.path"
        :isSideNav="isSideNav"
        :icon="link.icon"
        :isActive="$route.path === `/${link.path}`"
        @onNavLinkClick="rootCategoryClickHandler(link.path)"
      />
      <NavLink
        v-if="isShowPersonalArea"
        :title="'מועדפים'"
        :navigationName="'favorites'"
        :isSideNav="isSideNav"
        :icon="'mdi-star'"
        :isActive="$route.path === '/favorites'"
        @onNavLinkClick="rootCategoryClickHandler('favorites')"
      />
      <v-divider
        v-if="$route.name === 'home'"
        color="#808080"
        class="divider mt-2 mb-2"
      ></v-divider>
      <NavLink
        v-for="link in links"
        :title="link.title"
        :key="link.id"
        :isSideNav="isSideNav"
        :navigationName="link.path"
        :icon="link.icon"
        @onNavLinkClick="navClickHandler(link.path)"
      />
    </ul>
    <span class="empty-space"></span>

    <PersonalAreaBtn
      class="mb-14 mr-3 align-self-center"
      :userName="userName"
      :isAuth="isAuth"
    />
    <div class="pr-4">v{{ config.version }}</div>
  </div>
</template>

<script>
import PersonalAreaBtn from "./PersonalAreaBtn.vue";
import NavLink from "./NavLink.vue";
import ToCategoryBtn from "./ToCategoryBtn.vue";
import { mapGetters } from "vuex";
import config from "../../../config";
export default {
  components: { NavLink, ToCategoryBtn, PersonalAreaBtn },
  emits: ["closeSideMenu"],
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    userName: {
      type: String,
      default: null,
    },
    isAuth: {
      type: Boolean,
      default: false,
    },
    isShowPersonalArea: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
      isTablet: "isTablet",
    }),
    config() {
      return config;
    },
    isSideNav() {
      return !this.$store.getters.isDesktop;
    },
  },
  methods: {
    async navClickHandler(path) {
      if (path.startsWith("#")) {
        if (this.$router.name !== "home") {
          await this.$router.push("/");
        }
        const element = document.getElementById(path.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
        // close the side menu
        this.$emit("closeSideMenu");
      } else {
        this.$router.push(path);
      }
    },
    rootCategoryClickHandler(path) {
      this.$router.replace(`/${path}`, { replace: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.empty-space {
  // height: 150px;
  flex: 1;
}
.side-menu {
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.divider {
  width: 80%;
  margin: auto;
}
.links {
  display: flex;
  flex-direction: column;
  gap: 0px;
}
</style>
